const TOKEN_KEY = 'QS_ADMIN_TOKEN'

export function getToken () {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken (token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken () {
  localStorage.removeItem(TOKEN_KEY)
}
